import { Space, Tag } from "antd"
import dayjs from "dayjs"
import { useCallback, useEffect, useMemo, useState } from "react"

type TimeItem = { key: number, title: string, times: () => [dayjs.Dayjs, dayjs.Dayjs] }

const SwitchTags = ({ onChoose }: { onChoose: (v: { start: number; end: number; }) => void }) => {
  const [selected, setSelected] = useState<{ key: number, title: string, times: [dayjs.Dayjs, dayjs.Dayjs] } | undefined>()

  const times: TimeItem[] = useMemo(() => {
    return [
      {
        key: 99,
        title: '全部',
        times: () => ([dayjs("2017-08-28"), dayjs()])
      },
      {
        key: 100,
        title: '今年',
        times: () => ([dayjs().startOf("year"), dayjs()])
      },
      /*  {
         key: 105,
         title: '本季度',
         times: [dayjs().startOf("quarter"), dayjs()]
       }, */
      {
        key: 102,
        title: '上月',
        times: () => ([
          dayjs()
            .startOf("month")
            .subtract(1, "day")
            .startOf("month"),
          dayjs()
            .startOf("month")
            .subtract(1, "month")
            .endOf("month"),
        ])
      },
      {
        key: 101,
        title: '本月',
        times: () => ([dayjs().startOf("month"), dayjs()])
      }, {
        key: 103,
        title: '本周',
        times: () => ([dayjs().startOf("w"), dayjs()]),
      }, {
        key: 104,
        title: '今天',
        times: () => ([dayjs().startOf("day"), dayjs()]),
      }
    ]
  }, [])

  useEffect(() => {
    setSelected({ ...times[3], times: times[3].times() })
  }, [times])

  const onClick = useCallback((item: TimeItem) => {
    let ts = item.times()
    const start = parseInt(ts[0].startOf("day").format("X"));
    const end = parseInt(ts[1].endOf("day").format("X"));
    onChoose({ start, end })
    setSelected({ ...item, times: ts })
  }, [onChoose])

  return <Space>
    {
      times.map(item => (<Tag key={item.key} color={selected?.key === item.key ? 'orange' : "processing"} style={{ cursor: "pointer" }} onClick={onClick.bind(this, item)}>{item.title}</Tag>))
    }
    {selected !== undefined && <div>
      {selected.times[0].format("YYYY年MM月DD日")} ~ {selected.times[1].format("YYYY年MM月DD日")}
    </div>}
  </Space>
}

export default SwitchTags